module.exports = __webpack_public_path__ + "media/images/New_VS_Project-9f7638ec.png";